import { render, staticRenderFns } from "./AddonCart.vue?vue&type=template&id=3c9c8409"
import script from "./AddonCart.vue?vue&type=script&lang=ts"
export * from "./AddonCart.vue?vue&type=script&lang=ts"
import style0 from "./AddonCart.vue?vue&type=style&index=0&id=3c9c8409&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports